import { defineMessages } from 'react-intl';

export default defineMessages({
    information: {
        id: 'contact-agent.views.information',
        defaultMessage: 'Please contact your agent with any questions or concerns.'
    },
});
